import { useFetchPage } from "~/core/composables/useFetchPage";
import { SearchMode, useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_LIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import delegationService from "~/modules/relation/delegation/services/delegation.service";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

export function useFetchReceivedDelegations({
  organizationCode,
  businessUnitCode,
  searchMode = SearchMode.FILTER_SEARCH,
}: UseFetchParameters): UseFetchResponse<RelationEntity> {
  let service =
    delegationService.getBusinessUnitReceivedDelegations.bind(
      delegationService,
    );
  if (organizationCode) {
    service =
      delegationService.getOrganizationReceivedDelegations.bind(
        delegationService,
      );
  }

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.ORGANIZATION_NAME,
      {
        key: "organizationName",
        operator: OPERATOR_RSQL_LIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort } = useSort();
  const { isLoading, results, allResults, error, fetchData, fetchAllData } =
    useFetchPage({
      organizationCode,
      businessUnitCode,
      service,
      searchParams,
      sort,
    });

  return {
    isLoading,
    results,
    allResults,
    error,
    filters,
    fetchData,
    fetchAllData,
    setFilter,
    search,
    onSearch,
  };
}
